
import React, { useState, useEffect } from "react";
import ImageSelect from './ImageSelect';

const AiPrompt = ({
  isOpen,
  onClose,
  onSave,
  onLogout,
  auth,
  demo,
  aspectLock,
  rect,
  onImage,
  onCode,
  onScrollOpen,
  promptType,

}) => {

  const [formData, setFormData] = useState({
    rect: JSON.parse(JSON.stringify(rect)),
    referenceImage: "",
    includeSvg:false,
  });

  const [isApplying, setIsApplying] = useState(false);
  const [isImageSelectOpen, setIsImageSelectOpen] = useState(false);
  const [isBezier, setIsBezier] = useState(false);
  

  useEffect(() => {
    if (isOpen) {
      const tempRect = JSON.parse(JSON.stringify(rect));
  
      setFormData({
        rect: tempRect,
        referenceImage: "",
        includeSvg: false
      });


      if(tempRect.type === 'Bezier' && promptType !== "image")
      {
        setIsBezier(true);
      }
    }
  }, [isOpen, rect]);


  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };


  const handleSave = async () => {

    setIsApplying(true);

    try {

      if(promptType === "image")
      {
        if(onImage)
          await onImage(formData);
      }
      else
      {
        if(promptType === "vector")
        {
          if (onSave) {
            await onSave(formData);
          }
        }
        else
        {
          await onCode(formData);
        }
      }

      onClose();

    }
    catch (e) {
      console.error("Error applying AI command:", e);
    }
    finally {
      // Keep spinner active until dialog closes.
      // setIsApplying(false);
    }
  };


  function handleInputChange(e) 
  {
    const value = e.target.value;

    setFormData(prev => ({
      ...prev,
      rect: {
        ...prev.rect,
        description: value
      }
    }));
  }


  function renderSvgInclude()
  {
    if(promptType !== 'image' && promptType !== 'vector')
    {
      return (
                <div style={{ marginTop: "12px" }}>
                <button
                  type="button"
                  disabled={isApplying}
                  onClick={() => {
                    setFormData(prev => ({
                      ...prev,
                      includeSvg: !prev.includeSvg
                    }));
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                    padding: "5px 9px",
                    fontSize: "13px",
                    border: "1px solid #aaa",
                    borderRadius: "4px",
                    backgroundColor: "#f5f5f5",
                    cursor: isApplying ? "not-allowed" : "pointer",
                    opacity: isApplying ? 0.5 : 1
                  }}
                >
                  <span
                    style={{
                      width: "14px",
                      height: "14px",
                      border: "1px solid #777",
                      borderRadius: "3px",
                      backgroundColor: formData.includeSvg ? "#007bff" : "#fff",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: "bold"
                    }}
                  >
                    {formData.includeSvg ? "✓" : ""}
                  </span>
      
                  Include SVG in prompt
                </button>
              </div>
      )
    }
  }

  function handleImageSelect(r) {

    console.log("Reference image selected:", r.rect.imageName);

    handleChange("referenceImage", r.rect.imageName);

  }


  if (!isOpen) {
    return null;
  }


  const styles = {

    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },

    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },

    label: {
      display: "block",
      marginBottom: "8px",
      fontSize: "14px"
    },

    textarea: {
      display: "block",
      width: "100%",
      padding: "8px 10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
      resize: "vertical"
    },

    referenceSection: {
      marginTop: "15px"
    },

    referenceButton: {
      padding: "7px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "1px solid #aaa",
      backgroundColor: "#f5f5f5",
      cursor: "pointer"
    },

    referencePreview: {
      marginTop: "10px",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },

    previewImage: {
      width: "70px",
      height: "70px",
      objectFit: "contain",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#fafafa"
    },

    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },

    button: {
      padding: "6px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },

    cancel: {
      backgroundColor: "#e0e0e0"
    },

    save: {
      backgroundColor: "#007bff",
      color: "#fff",
      minWidth: "65px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

  };


  return (

    <div style={styles.backdrop}>

      <div style={styles.modal}>

        {/* AI Prompt */}
        <div>

          <label style={styles.label}>
            Enter AI Prompt:
          </label>

          <textarea
            name="description"
            value={formData.rect?.description || ""}
            onChange={handleInputChange}
            rows={3}
            style={styles.textarea}
            disabled={isApplying}
          />
        </div>


        {/* Reference Image */}
        {!isBezier && (
          <div style={styles.referenceSection}>
            <label style={styles.label}>
              Reference Image: {formData.referenceImage}
            </label>

            <button
              type="button"
              style={{
                ...styles.referenceButton,
                opacity: isApplying ? 0.5 : 1,
                cursor: isApplying ? "not-allowed" : "pointer"
              }}
              disabled={isApplying}
              onClick={() => {
                if(onScrollOpen)
                {
                  onScrollOpen(true);
                }
                setIsImageSelectOpen(true);
              }}
            >
              Select Image
            </button>
          </div>
        )}

        {renderSvgInclude()}


        {/* Buttons */}

        <div style={styles.modalButtons}>

          <button
            style={{
              ...styles.button,
              ...styles.cancel,
              opacity: isApplying ? 0.5 : 1,
              cursor: isApplying
                ? "not-allowed"
                : "pointer"
            }}
            onClick={onClose}
            disabled={isApplying}
          >
            Cancel
          </button>


          <button
            style={{
              ...styles.button,
              ...styles.save,
              cursor: isApplying
                ? "wait"
                : "pointer",
            }}
            onClick={handleSave}
            disabled={isApplying}
          >

            {isApplying ? (

              <span
                style={{
                  width: "14px",
                  height: "14px",
                  border: "2px solid rgba(255,255,255,0.4)",
                  borderTop: "2px solid white",
                  borderRadius: "50%",
                  display: "inline-block",
                  animation:
                    "aiPromptSpin 0.7s linear infinite",
                }}
              />

            ) : (

              "Apply"

            )}
          </button>
          {isImageSelectOpen && (
                <ImageSelect
                  isOpen={true}
                  onClose={() => {  
                                // setOperation("select");                       
                                if(onScrollOpen)
                                {
                                  onScrollOpen(false);
                                }
                                setIsImageSelectOpen(false);                          
                              }}
                  onSave={handleImageSelect}
                  onLogout = {onLogout}
                  auth = {auth}
                  demo = {demo}
                  aspectLock = {aspectLock}
                  excludeSvg = {true}
                  rectData={formData.rect} />            
            )}


        </div>

      </div>


      <style>
        {`
          @keyframes aiPromptSpin {
            from {
              transform: rotate(0deg);
            }

            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

    </div>

  );
};


export default AiPrompt;


